import styled from 'styled-components';

export const EmptyPageWrapper = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, 50%);
  text-align: center;
  padding: 20px;
  font-family: 'Poppins' sans-serif;
  font-style: normal;
  width: 100%;
`;

export const EmptyPageHeading = styled.h3`
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  color: #1b203a;
  margin: unset unset 8px unset;
`;

export const EmptyPageMessage = styled.p`
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #474d66;
  margin: unset;
`;
